import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OOVenueService } from "src/app/core/services/venue-service";
import { OOCanvas } from "src/app/shared/models/oo-canvas";
import { OOCanvasMenuItem } from "src/app/shared/models/oo-canvas-menu-item.model";

@Component({
	selector: "app-subscription-menu-menu-items",
	templateUrl: "./subscription-menu-menu-items.component.html",
	styleUrls: ["../../subscription.scss"],
})
export class SubscriptionMenuMenuItemsComponent implements OnInit {
	@Input() canvas: OOCanvas;
	@Output() canvasChange = new EventEmitter<OOCanvas>();

	selectedItem: OOCanvasMenuItem;

	timestamp = new Date();

	constructor(public app: AppService, public venueService: OOVenueService) {}

	ngOnInit(): void {}
}
